(function(){
  // initialize variables
  var magnifying_area =  document.querySelectorAll(".media-container .carousel-main .carousel-cell .media");
  var magnifying_area_popup =  document.querySelectorAll(".product-popup-modal__content-info .carousel-cell .media");
  var $flkty_carousel_nav = document.querySelector('.product-popup-modal--zoom .carousel-navi');
  var $carouselNavCells = $flkty_carousel_nav.querySelectorAll('.carousel-navi .carousel-cell');
  var $carouselItems = document.querySelectorAll('.product-popup-modal--zoom .carousel .carousel-cell');
  var $carousel = document.querySelector('.product-popup-modal--zoom .carousel');
  var closeBtn = document.querySelector('.product-popup-modal--zoom .product-popup-modal__toggle');
  var closeBtnMobile = document.querySelector('.wrapper__btns .mobile-close');
  var previousBtnMobile = document.querySelector('.wrapper__btns .prev-button');
  var nextBtnMobile = document.querySelector('.wrapper__btns .next-button');
  var slideNum = document.querySelector('.wrapper__btns .current-slide');
  let zoomScreenSize = window.matchMedia("(max-width: 990px)");
  let zoomIsDraggable = false;
  var $flkty = null;
  let flickityIndex = 0;

  // desktop hover zoom
  magnifying_area.forEach(item => {
      if(window.innerWidth >= 990){
          item.addEventListener("mousemove", function(event){
              let clientX = event.offsetX;
              let clientY = event.offsetY;

              let mWidth = item.offsetWidth;
              let mHeight = item.offsetHeight;
              clientX = clientX / mWidth * 100;
              clientY = clientY / mHeight * 100;
              let magnifying_img = item.querySelector('img')
              magnifying_img.style.transform = 'translate(-' +  clientX + '%, -' + clientY + '%) scale(2)'
          })
          item.addEventListener("mouseleave", function(){
              let magnifying_img = item.querySelector('img')
              magnifying_img.style.transform = 'translate(0%, 0%) scale(1)'
          })
      }
      item.addEventListener('click', function(event){
          if(event.target.dataset.sectionId && event.target.dataset.index){
              const modal = document.querySelector(`#main-product-zoom-${event.target.dataset.sectionId}`);
              if (modal) modal.show();
              // update flickity index
              flickityIndex = event.target.dataset.index;
              $flkty.select(flickityIndex)
              // update selected nav
              $carouselNavCells.forEach(nav_carousel => {
                nav_carousel.classList.remove('is-nav-selected');
              });
              $carouselNavCells.forEach(carousel_cell => {
                if(carousel_cell.dataset.index == flickityIndex)
                  carousel_cell.classList.add('is-nav-selected');
              })
          }
      });
  })
  magnifying_area_popup.forEach(item =>{
    if(window.innerWidth < 990){
      let isZoomed = false;
      const zoomFactor = 2; // Zoom factor (2 means double the size)
      let lastTapTime = 0;
      let lastTapX = 0;
      let lastTapY = 0;
      item.addEventListener('click', function(event) {
        const currentTime = new Date().getTime();

        if (currentTime - lastTapTime < 300) {
          const rect = this.getBoundingClientRect();
          const x = event.clientX - rect.left;
          const y = event.clientY - rect.top;

          if (!isZoomed) {
            lastTapX = x;
            lastTapY = y;
            // zoomableContainer.style.overflow = 'hidden';
            item.style.transformOrigin = `${x}px ${y}px`;
            item.style.transform = `scale(${zoomFactor})`;
            isZoomed = true;
          } else {
            item.style.transform = 'scale(1)';
            isZoomed = false;
          }
        } else {
          lastTapTime = currentTime;
        }
      });
    }
  })
  // desktop popup zoom
  if(window.innerWidth >= 990){
    $carouselItems.forEach(item => {
      item.addEventListener('click', () =>{
          if(closeBtn.classList.contains('zoom')){
            closeBtn.classList.remove('zoom')
          }else{
            closeBtn.classList.add('zoom')
          }
          if($carousel.classList.contains('zoom')){
            $carousel.classList.remove('zoom')
          }else{
            $carousel.classList.add('zoom')
          }
          setTimeout(() => {
            $flkty.destroy();
            iniate_flickity();
          }, 10);
      })
    })
  }
  // mobile carousel control
  window.addEventListener('load', () => {
    let previousBtn = document.querySelector('.product-popup-modal--zoom .carousel .flickity-button.previous');
    let nextBtn = document.querySelector('.product-popup-modal--zoom .carousel .flickity-button.next');

    if(previousBtnMobile && nextBtnMobile && previousBtn
      && nextBtn && closeBtn && closeBtnMobile){
      previousBtnMobile.addEventListener('click', () =>{
        previousBtn.click();
      })
      nextBtnMobile.addEventListener('click', () =>{
        nextBtn.click();
      })
      closeBtnMobile.addEventListener('click', () =>{
        closeBtn.click();
      })
    }
  });
  // init popup carousel
  function iniate_flickity(){
      if(zoomScreenSize.matches)
        zoomIsDraggable = true;
          $flkty = new Flickity($carousel,{
          prevNextButtons: true,
          pageDots: false,
          fullscreen: false,
          lazyLoad: 0,
          draggable: zoomIsDraggable,
          passive: false,
          wrapAround: true,
          setGallerySize: true,
          adaptiveHeight: true,
          initialIndex: flickityIndex
      });
      //to provide smooth dragging
      $flkty.on('dragStart', () => (document.ontouchmove = () => false));
      $flkty.on('dragEnd', () => (document.ontouchmove = () => true));
      $flkty.on( 'change', (index) => {
        if(slideNum)
          slideNum.innerHTML = index + 1;
      });
      //to provide smooth dragging
      select_nav_cell($flkty)
  }

  function select_nav_cell($flkty){
      $carouselNavCells.forEach(carousel_cell => {
          carousel_cell.addEventListener('click', event => {
            $carouselNavCells.forEach(nav_carousel => {
                nav_carousel.classList.remove('is-nav-selected');
            });
            carousel_cell.classList.add('is-nav-selected');
            flickityIndex = event.currentTarget.getAttribute('data-index');
            $flkty.next();
            $flkty.select(flickityIndex)
          })
      });
  }

  // desktop nav btns control
  function disableBtnsOnScroll(){
    // let btn_downElem = document.querySelector('.btn-down');
    let $flkty_carousel_nav = document.querySelector('.product .carousel-nav');
    let btn_upElem = document.querySelector('.btn-up');
    let element = $flkty_carousel_nav.querySelectorAll('.carousel-cell')[0];
    let oldPosition = element.getBoundingClientRect();
    $flkty_carousel_nav.addEventListener('scroll', function(e){
        let currentPosition = element.getBoundingClientRect();
        if(currentPosition.top < oldPosition.top){
            btn_upElem.disabled = false;
        }else{
            btn_upElem.disabled = true;
        }
    })
  }

  // run functions
  disableBtnsOnScroll();
  iniate_flickity();
})();